export const columnDefSuppressHeaderFilterButton = {
  suppressHeaderFilterButton: true,
};
